"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/** @jsx jsx */
var core_1 = require("@theme-ui/core");
var mdx_1 = require("@theme-ui/mdx");
var react_1 = require("react");
var OutboundLink = function (_a) {
    var children = _a.children, className = _a.className, href = _a.href, onClick = _a.onClick, title = _a.title;
    return ((0, core_1.jsx)(mdx_1.Themed.a, { href: href, title: title, target: "_blank", rel: "noreferrer", className: className, onClick: onClick }, children));
};
exports.default = (0, react_1.memo)(OutboundLink);
